package pl.decks.personal.components.widgets.responsivegrid

import androidx.compose.runtime.Composable

data class ResponsiveGridOption(
    val title: String? = null,
    val content: (@Composable () -> Unit)? = null,
) {
    init {
        require((title != null) != (content != null)) {
            "You can specify only title or content, and at most one of them"
        }
    }
}
